import { ApiService } from "./ApiService";

export class AuthServices {

    static logOut() {
        localStorage.removeItem("token");
    }

static async getAuth() {
    return ApiService.get('users/get-authenticated-user')
  }

    static async login(model) {
        try {
            return ApiService.post("users/login", model).then(
                response => {
                    return response
                }
            );
        } catch (err) {
            return err;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js